export default values => {
  const errors = {};

  if (values.files) {
    if (values.files.length > 10) {
      errors.files = { _error: 'Maximum 10 files' };
    }
    const filesArrayErrors = [];
    values.files.forEach((field, index) => {
      const fieldErrors = {};
      if (!field.name) {
        fieldErrors.name = { _error: 'Required' };
      } else if (`${field.name}.${field.extension}`.length > 64) {
        fieldErrors.name = { _error: `Maximum ${63 - field.extension.length} characters` };
      }

      if (field.description?.length > 255) {
        fieldErrors.description = { _error: 'Maximum 255 characters' };
      }

      filesArrayErrors[index] = fieldErrors;
    });

    if (filesArrayErrors.length) {
      if (errors.files) {
        // eslint-disable-next-line no-underscore-dangle
        filesArrayErrors._error = errors.files._error;
      }
      errors.files = filesArrayErrors;
    }
  }

  return errors;
};
